var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "divBox",
      on: {
        click: function ($event) {
          _vm.isSortShow = false
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "v-height-flag", staticStyle: { height: "100%" } },
        [
          _c(
            "el-card",
            { staticClass: "card-box", attrs: { "body-style": "padding:0;" } },
            [
              _vm.switchIndex != 7
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.gridl, false),
                        [
                          _c("cloudfile-left", {
                            ref: "cloudfileLeft",
                            on: { confirmData: _vm.confirmData },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        _vm._b(
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.uploadLoading,
                                expression: "uploadLoading",
                              },
                            ],
                            attrs: { "element-loading-text": "文件正在上传中" },
                          },
                          "el-col",
                          _vm.gridr,
                          false
                        ),
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cloudfile-right",
                              attrs: { id: "cloudfile-right" },
                            },
                            [
                              _c("formBox", {
                                attrs: {
                                  breadcrumbArray: _vm.breadcrumbArray,
                                  pid: _vm.pid,
                                  spaceId: _vm.spaceId,
                                  switchIndex: _vm.switchIndex,
                                  total: _vm.total,
                                },
                                on: {
                                  formBoxClick: _vm.formBoxClick,
                                  handleCommand: _vm.handleCommand,
                                  isUploading: _vm.isUploading,
                                  isUploaded: _vm.isUploaded,
                                  handleSort: _vm.handleSort,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { staticClass: "mt10" },
                                [
                                  _vm.switchIndex == 1
                                    ? _c("lately-file", {
                                        ref: "latelyFile",
                                        attrs: {
                                          "file-style": _vm.fileStyle,
                                          pageLimit: _vm.pageLimit,
                                          "space-id": _vm.spaceId,
                                          spaceType: _vm.spaceType,
                                          wps_type: _vm.wps_type,
                                        },
                                        on: {
                                          handlerMyFile: _vm.handlerMyFile,
                                          shareItemFile: _vm.shareFile,
                                          openItemFile: _vm.openfile,
                                          totalFn: _vm.totalFn,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.switchIndex == 6
                                    ? _c("space-file", {
                                        ref: "spaceFile",
                                        attrs: {
                                          "file-style": _vm.fileStyle,
                                          pageLimit: _vm.pageLimit,
                                          "space-id": _vm.spaceId,
                                          spaceType: _vm.spaceType,
                                          switch: _vm.switchIndex,
                                          wps_type: _vm.wps_type,
                                        },
                                        on: {
                                          handlerMyFile: _vm.handlerMyFile,
                                          openItemFile: _vm.openfile,
                                          shareItemFile: _vm.shareFile,
                                          totalFn: _vm.totalFn,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.switchIndex == 7
                ? _c("recovery-file", {
                    ref: "recoveryFile",
                    attrs: {
                      "ent-button": _vm.entButton,
                      "file-style": _vm.fileStyle,
                      "space-id": _vm.spaceId,
                      wps_type: _vm.wps_type,
                    },
                    on: { backFn: _vm.backFn },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("newFileDialog", {
        ref: "newFileDialog",
        attrs: { config: _vm.configMyFile },
        on: { handleIsOK: _vm.handleIsOK },
      }),
      _vm._v(" "),
      _c("move-dialog", {
        ref: "moveDialog",
        attrs: { "move-data": _vm.moveData },
        on: { handlerMove: _vm.handlerMove },
      }),
      _vm._v(" "),
      _c("fileDialog", { ref: "viewFile" }),
      _vm._v(" "),
      _c("file-temp", {
        ref: "fileTemp",
        attrs: { "from-data": _vm.fileTemp },
        on: { handleTemplate: _vm.handleTemplate },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }